import { render } from "./ColorPill.vue?vue&type=template&id=0698f491"
import script from "./ColorPill.vue?vue&type=script&lang=js"
export * from "./ColorPill.vue?vue&type=script&lang=js"

import "./ColorPill.vue?vue&type=style&index=0&id=0698f491&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__